import React   from 'react' ;
import PageCh10_t1 from './pageCh10_t1';
import PageCh10_t2 from './pageCh10_t2';
import PageCh10_t3 from './pageCh10_t3';
import Pagech10_t4 from './pageCh10_t4';
import Pagech10_t5 from './pageCh10_t5';
import PageCh10_t6Ali from './pageCh10_t6Ali'
const   PageCh10 = ()=>{
     
       
    return (
      <>  <hr/> 
      <h1 className="m-2" >PageCh10 (chapter 10)</h1>
       <PageCh10_t1 />  
       <PageCh10_t2 /> 
       <PageCh10_t3 /> 
       <Pagech10_t4 /> 
       <Pagech10_t5 /> 
       <PageCh10_t6Ali />
      </>
    )
     
} 
export default PageCh10
